//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import { Permission } from '../../../Common/Permission';
import PermisoManager from '../../../Common/Managers/PermisoManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS = "GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS";
export const SET_USER_FUNCTIONS_PERMISOSMASIVOS = 'SET_USER_FUNCTIONS_PERMISOSMASIVOS';
export const GET_SCREEN_DATA_PERMISOSMASIVOS_SUCCESS = 'GET_SCREEN_DATA_PERMISOSMASIVOS_SUCCESS';
export const RESET_STATE_PERMISOSMASIVOS = 'RESET_STATE_PERMISOSMASIVOS';
export const REDIRECT_OK_PERMISOSMASIVOS = 'REDIRECT_OK_PERMISOSMASIVOS';
export const ELIMINAR_PERFIL_PERMISOSMASIVOS = 'ELIMINAR_PERFIL_PERMISOSMASIVOS';
export const GUARDAR_PERFILES_PERMISOSMASIVOS = 'GUARDAR_PERFILES_PERMISOSMASIVOS';
export const AGREGAR_FUNCION_PERMISOSMASIVOS = 'AGREGAR_FUNCION_PERMISOSMASIVOS';
export const ELIMINAR_FUNCION_PERMISOSMASIVOS = 'ELIMINAR_FUNCION_PERMISOSMASIVOS';
export const AGREGAR_USUARIO_PERMISOSMASIVOS = 'AGREGAR_USUARIO_PERMISOSMASIVOS';
export const ELIMINAR_USUARIO_PERMISOSMASIVOS = 'ELIMINAR_USUARIO_PERMISOSMASIVOS';
export const AGREGAR_PERMISO_PERMISOSMASIVOS = 'AGREGAR_PERMISO_PERMISOSMASIVOS';
export const ELIMINAR_PERMISO_PERMISOSMASIVOS = 'ELIMINAR_PERMISO_PERMISOSMASIVOS';
export const SELECT_PRODUCTO_PERMISOSMASIVOS = 'SELECT_PRODUCTO_PERMISOSMASIVOS';
export const SELECT_CATEGORIA_PERMISOSMASIVOS = 'SELECT_CATEGORIA_PERMISOSMASIVOS';
export const SELECT_PROGRAMA_PERMISOSMASIVOS = 'SELECT_PROGRAMA_PERMISOSMASIVOS';
export const AGREGAR_TODASFUNCIONES_PERMISOSMASIVOS = 'AGREGAR_TODASFUNCIONES_PERMISOSMASIVOS';
export const ELIMINAR_TODASFUNCIONES_PERMISOSMASIVOS = 'ELIMINAR_TODASFUNCIONES_PERMISOSMASIVOS';
export const SAVE_PERMISOS_RESULT_PERMISOSMASIVOS = 'SAVE_PERMISOS_RESULT_PERMISOSMASIVOS';
export const SET_ERROR_MESSAGES_PERMISOSMASIVOS = 'SET_ERROR_MESSAGES_PERMISOSMASIVOS';
export const ESCONDER_POPUP_PERMISOSMASIVOS = 'ESCONDER_POPUP_PERMISOSMASIVOS';
export const MOSTRAR_MAS_PERFILES_PERMISOS_MASIVOS = 'MOSTRAR_MAS_PERFILES_PERMISOS_MASIVOS';
export const MOSTRAR_MENOS_PERFILES_PERMISOS_MASIVOS = 'MOSTRAR_MENOS_PERFILES_PERMISOS_MASIVOS';
export const OPEN_MODAL_PERMISOS_NO_ASIGNADOS = 'OPEN_MODAL_PERMISOS_NO_ASIGNADOS';

/**
 * Variables globales
 */
let _dispatch, _currentScope = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenDataCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Resetea el estado de la pantalla
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_PERMISOSMASIVOS });
    }
}

/**
 * Setea en true la bandera que redireccionaa Perfiles y Permisos
 */
export function setRedirectOk() {
    LogHelper.In(setRedirectOk.name);

    if (sessionStorage.getItem('PantallaCambios') == "true") {
        sessionStorage.removeItem('PantallaCambios');
    }

    return (dispatch) => {
        _dispatch = dispatch;

        $("#confirm-cancel").modal('toggle');

        _setRedirect();
    }
}

/**
 * Elimina el perfil de la lista de seleccionados
 * @param {any} idPerfil
 */
export function deletePerfil(idPerfil) {
    LogHelper.In(deletePerfil.name, idPerfil);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ELIMINAR_PERFIL_PERMISOSMASIVOS, idPerfil });
    }
}

/**
 * Guarda en el state los perfiles seleccionados del modal
 * @param {any} perfilesSeleccionados
 */
export function savePerfiles(perfilesSeleccionados) {
    LogHelper.In(savePerfiles.name, perfilesSeleccionados);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: GUARDAR_PERFILES_PERMISOSMASIVOS, perfilesSeleccionados });
    }
}

/**
 * Chequea/deschequea la funcion
 * @param {any} idPermiso
 * @param {any} idFuncion
 * @param {any} checked
 */
export function checkFuncion(idPermiso, idFuncion, checked) {
    LogHelper.In(checkFuncion.name, idPermiso, idFuncion, checked);

    return (dispatch) => {
        _dispatch = dispatch;

        if (checked == true) {
            dispatch({ type: ELIMINAR_FUNCION_PERMISOSMASIVOS, idPermiso, idFuncion });
        }
        else if (checked == false) {
            dispatch({ type: AGREGAR_FUNCION_PERMISOSMASIVOS, idPermiso, idFuncion });
        }
    }
}

/**
 * Agrega un usuario al array de usuariosSeleccionados
 * @param {any} login
 */
export function addUsuario(login) {
    LogHelper.In(addUsuario.name, login);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: AGREGAR_USUARIO_PERMISOSMASIVOS, login });
    }
}

/**
 * Elimina un usuario del array de usuariosSeleccionados
 * @param {any} login
 */
export function deleteUsuario(login) {
    LogHelper.In(deleteUsuario.name, login);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: ELIMINAR_USUARIO_PERMISOSMASIVOS, login });
    }
}

/**
 * Agrega un nuevo permiso
 */
export function addPermiso() {
    LogHelper.In(addPermiso.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().permisosMasivos));
        let permisos = state.permisos;
        let ultimoPermiso = permisos[permisos.length - 1];
        let permiso = new Permission(ultimoPermiso.id + 1, state.productos, state.categorias, state.programas, []);

        permisos.push(permiso);

        dispatch({ type: AGREGAR_PERMISO_PERMISOSMASIVOS, permisos });
    }
}

/**
 * Elimina el permiso
 * @param {any} idPermiso
 */
export function deletePermiso(idPermiso) {
    LogHelper.In(deletePermiso.name, idPermiso);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: ELIMINAR_PERMISO_PERMISOSMASIVOS, idPermiso });
    }
}

/**
 * Filtra el producto en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} id
 */
export function selectProducto(idPermiso, id) {
    LogHelper.In(selectProducto.name, idPermiso, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().permisosMasivos));
        let localValue = {
            'PRODUCT_ID': (id == 0) ? undefined : id,
            'CATEGORY_ID': undefined,
            'PROGRAM_ID': undefined
        }

        LogHelper.Out(selectProducto.name, localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesProductoCallback(data, idPermiso, id), null, null, "SEGURIDAD");
    }
}

/**
 * Filtra la categoria en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} id
 */
export function selectCategoria(idPermiso, id) {
    LogHelper.In(selectCategoria.name, idPermiso, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().permisosMasivos));
        let localValue = {
            'PRODUCT_ID': state.permisos.find(x => x.id == idPermiso).productoId,
            'CATEGORY_ID': (id == 0) ? undefined : id,
            'PROGRAM_ID': undefined
        }

        LogHelper.Out(selectCategoria.name, localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesCategoriaCallback(data, idPermiso, id), null, null, "SEGURIDAD");
    }
}

/**
 * Filtra el programa en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} id
 */
export function selectPrograma(idPermiso, id) {
    LogHelper.In(selectPrograma.name, idPermiso, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().permisosMasivos));
        let localValue = {
            'PRODUCT_ID': state.permisos.find(x => x.id == idPermiso).productoId,
            'CATEGORY_ID': state.permisos.find(x => x.id == idPermiso).categoriaId,
            'PROGRAM_ID': (id == 0) ? undefined : id
        }

        LogHelper.Out(selectPrograma.name, localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesProgramaCallback(data, idPermiso, id), null, null, "SEGURIDAD");
    }
}

/**
 * Agrega todas las funciones al permiso
 * @param {any} idPermiso
 */
export function selectTodasFunciones(idPermiso) {
    LogHelper.In(selectTodasFunciones.name, idPermiso);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: AGREGAR_TODASFUNCIONES_PERMISOSMASIVOS, idPermiso });
    }
}

/**
 * Elimina todas las funciones del permiso
 * @param {any} idPermiso
 */
export function unselectTodasFunciones(idPermiso) {
    LogHelper.In(unselectTodasFunciones.name, idPermiso);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: ELIMINAR_TODASFUNCIONES_PERMISOSMASIVOS, idPermiso });
    }
}

/**
 * Impacta los cambios en la BD
 */
export function savePermisos() {
    LogHelper.In(savePermisos.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().permisosMasivos));
        getPermisosUsuarios(state.perfilesSeleccionados, state.permisos, state.usuariosSeleccionados, state);
    }
}

/**
 * Esconde pop up
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_PERMISOSMASIVOS });
    }
}

/**
 * Muesatra todos los perfiles seleccionados
 */
export function showMoreProfiles() {
    LogHelper.In(showMoreProfiles.name);

    return (dispatch) => {
        dispatch({ type: MOSTRAR_MAS_PERFILES_PERMISOS_MASIVOS });
    }
}

/**
 * Oculta los perfiles seleccionados
 */
export function showLessProfiles() {
    LogHelper.In(showLessProfiles.name);

    return (dispatch) => {
        dispatch({ type: MOSTRAR_MENOS_PERFILES_PERMISOS_MASIVOS });
    }
}


/**
 * Oculta los perfiles seleccionados
 */
export function openModal() {
    return (dispatch) => {
        dispatch({ type: OPEN_MODAL_PERMISOS_NO_ASIGNADOS });
    }
}
/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion callback de la obtencion de los perfiles por producto.
 * @param {any} data
 */
function getPerfilesByProductoCallback(data) {
    LogHelper.In(getPerfilesByProductoCallback.name, data);

    let result = null;

    result = {
        'GET_PERFILES_BY_PRODUCTO': JSON.parse(data.GET_PERFILES_BY_PRODUCTO).Recordset0.Rows != undefined ? JSON.parse(data.GET_PERFILES_BY_PRODUCTO).Recordset0.Rows : null,
    }

    _dispatch({ type: GET_PERFILES_BY_PRODUCTO_FROM_PERMISOS_MASIVOS, result });
}

/**
 * Funcion callback de las funciones de seguridad.
 * @param {any} data
 */
function _loadScreenDataCallback(data) {
    LogHelper.In(_loadScreenDataCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_PERMISOSMASIVOS, functions });

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_ALL_USERLOGINS_ABLE', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_USERLOGINS_ABLE', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PRODUCTOS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PRODUCTOS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_CATEGORIAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CATEGORIAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PROGRAMAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROGRAMAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

    Engine1Proxy.Execute(_loadPermisosMasivosInitialStateCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadPermisosMasivosInitialStateCallback(data) {
    LogHelper.In(_loadPermisosMasivosInitialStateCallback.name, data);

    let result = {
        GET_PERFILES: JSON.parse(data.GET_PERFILES).Recordset0.Rows,
        GET_ALL_USERLOGINS_ABLE: JSON.parse(data.GET_ALL_USERLOGINS_ABLE).Recordset0.Rows,
        GET_PRODUCTOS: JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        GET_CATEGORIAS: JSON.parse(data.GET_CATEGORIAS).Recordset0.Rows,
        GET_PROGRAMAS: JSON.parse(data.GET_PROGRAMAS).Recordset0.Rows,
        GET_FUNCTIONS_BY_PERMISSION: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows,
        permisos: []
    };

    //Elimino de la lista de usuarios a filtrar el usuario logueado
    result.GET_ALL_USERLOGINS_ABLE.splice(result.GET_ALL_USERLOGINS_ABLE.findIndex(
        x => x.Id == _currentScope.UserId), 1);

    // Agrego campo eliminado, sera usado en la pantalla asignar usuario masivamente.
    result.GET_ALL_USERLOGINS_ABLE.forEach(function (item) { item.Eliminado = false });

    result.GET_PRODUCTOS.unshift({ Id: 0, Descripcion: "Seleccione un producto..." });
    result.GET_CATEGORIAS.unshift({ Id: 0, Descripcion: "Seleccione una categoria..." });
    result.GET_PROGRAMAS.unshift({ Id: 0, Descripcion: "Seleccione un programa..." });

    //Pusheo permiso inicial
    result.permisos.push(new Permission(1, result.GET_PRODUCTOS, result.GET_CATEGORIAS, result.GET_PROGRAMAS, []));

    _dispatch({ type: GET_SCREEN_DATA_PERMISOSMASIVOS_SUCCESS, result });
}

/**
 * Redirecciona a Perfiles y Permisos
 */
function _setRedirect() {
    LogHelper.In(_setRedirect.name);

    _dispatch({ type: REDIRECT_OK_PERMISOSMASIVOS });
}

/**
 * Callback de funcionalidades al seleccionar un producto
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} id
 */
function _funcionalidadesProductoCallback(data, idPermiso, id) {
    LogHelper.In(_funcionalidadesProductoCallback.name, data, idPermiso, id);

    let result = {
        idPermiso: idPermiso,
        id: id,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_PRODUCTO_PERMISOSMASIVOS, result });
}

/**
 * Callback de funcionalidades al seleccionar una categoria
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} id
 */
function _funcionalidadesCategoriaCallback(data, idPermiso, id) {
    LogHelper.In(_funcionalidadesCategoriaCallback.name, data, idPermiso, id);

    let result = {
        idPermiso: idPermiso,
        id: id,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_CATEGORIA_PERMISOSMASIVOS, result });
}

/**
 * Callback de funcionalidades al seleccionar un programa
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} id
 */
function _funcionalidadesProgramaCallback(data, idPermiso, id) {
    LogHelper.In(_funcionalidadesProgramaCallback.name, data, idPermiso, id);

    let result = {
        idPermiso: idPermiso,
        id: id,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_PROGRAMA_PERMISOSMASIVOS, result });
}

function getPermisosUsuarios(perfiles, permisos, usuarios, state) {

    let localvalues = {
        'PRODUCTO_ID': null,
        'CATEGORIA_ID': null,
        'PROGRAMA_ID': null,
        'USUARIO_ID': null
    }

    LogHelper.Out(getPermisosUsuarios.name, localvalues, 'GET_PERMISOS_BY_USUARIO', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_PERMISOS_BY_USUARIO', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.Execute((data) => guardarPermisos(data, perfiles, permisos, usuarios, state), null, null, "SEGURIDAD");
}

/**
 * Arma los llamados para guardar los permisos
 * @param {any} perfiles
 * @param {any} permisos
 * @param {any} usuarios
 */
function guardarPermisos(data, perfiles, permisos, usuarios, state) {
    LogHelper.In(guardarPermisos.name, perfiles, permisos, usuarios);

    let localValues = {};
    let funcionalidades = [];
    let permissions = [];

    //Obtengo los permisos de los usuarios de la BD
    let permisosBD = JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset0.Rows != undefined ? JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset0.Rows : null;

    //Agrega los permisos a los perfiles.
    perfiles.forEach(function (perfil) {
        permisos.forEach(function (permiso) {
            if (perfil.ProductoId == null || perfil.ProductoId == permiso.productoId)
                permiso.funciones.forEach(function (funcion) {
                    localValues = {
                        'PERFIL_ID': perfil.Id,
                        'PRODUCTO_ID': permiso.productoId,
                        'CATEGORIA_ID': permiso.categoriaId,
                        'PROGRAMA_ID': permiso.programaId,
                        'FUNCION_ID': funcion.id
                    }

                    funcionalidades.push(localValues);
                });
        });
    });

    //Agrega los permisos a los usuarios de la lista.
    usuarios.forEach(function (usuario) {
        permisos.forEach(function (permiso) {
            permiso.funciones.forEach(function (funcion) {
                localValues = {
                    'PERMISO': 1,
                    'USUARIO_ID': usuario.Id,
                    'PRODUCTO_ID': /*(permiso.productoId == 0) ? undefined :*/ permiso.productoId,
                    'CATEGORIA_ID': /*(permiso.categoriaId == 0) ? undefined :*/ permiso.categoriaId,
                    'PROGRAMA_ID': /*(permiso.programaId == 0) ? undefined :*/ permiso.programaId,
                    'FUNCION_ID': funcion.id
                }

                permissions.push(localValues);
            });
        });
    });

    let errorPermisosValidadosBD = validarPermisosBD(permisosBD,permissions);
    let permisosValidados;

    if(!errorPermisosValidadosBD)
        permisosValidados = validarPermisos(state);
    else
        permisosValidados = "Existen una o mas asignaciones de permisos duplicadas para el/los usuario/s.";


    if ((funcionalidades.length > 0 || permissions.length > 0) && permisosValidados == null) {
        _dispatch({ type: GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS });

        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }

        PermisoManager.UpdatePermisosMasivos(funcionalidades, permissions, SagasHelper.GetSagasId, ejecutarPorEstado);
    }
    else {
        let messages = {
            global: "Hay datos que requieren ser completados",
            globalClass: "error",
            globalHidden: false,
            perfilesUsuarios: "",
            funciones: "",
        };

        if (usuarios.length < 1 && perfiles.length < 1) {
            messages.perfilesUsuarios = "Por favor, seleccione uno o varios perfiles/usuarios";
        }

        if (permisos[0].funciones.length < 1) {
            messages.funciones = "Por favor, seleccione una o varias funciones";
        }

        if (permisosValidados != null) {
            messages.global = permisosValidados;
        }

        _dispatch({ type: SET_ERROR_MESSAGES_PERMISOSMASIVOS, messages });
    }
}

function validarPermisosBD(permisosBD, permisosSeleccionados) {
    let permisosEncontrados = [];
    let ErrorPermisos = false;

    permisosBD.map((per) => {
        permisosEncontrados = permisosSeleccionados.filter(p => p.PRODUCTO_ID == per.ProductoId && p.CATEGORIA_ID == per.CategoriaId && 
                                p.PROGRAMA_ID == per.ProgramaId && per.FuncionId == p.FUNCION_ID && p.USUARIO_ID == per.UsuarioId);        
        if (permisosEncontrados.length > 0)
            ErrorPermisos = true;
    });
    return ErrorPermisos;
}

function validarPermisos(state) {
    const productos = state.productos;
    const categorias = state.categorias;
    const programas = state.programas;
    let permisos = state.permisos;
    var msjErrorPermisos = null;

    productos.map((prod) => {
        categorias.map((cat) => {
            programas.map((prog) => {
                var permisosEncontrados = permisos.filter(p => p.productoId == prod.Id && p.categoriaId == cat.Id && p.programaId == prog.Id);
                if (permisosEncontrados.length > 1)
                    msjErrorPermisos = "Existen una o mas asignaciones de permisos duplicadas, por favor corrija esto para continuar.";
            })
        })
    });
    return msjErrorPermisos;
}

/**
 * 
 * @param {any} data
 */
function _savePermisosCallback(data) {
    LogHelper.In(_savePermisosCallback.name, data);

    _dispatch({ type: SAVE_PERMISOS_RESULT_PERMISOSMASIVOS });
}

/**
 * Callback de llamado a Sagas en el alta/edicion de usuario
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    let messages = {
        global: "Hubo un error al procesar la transacci\u00F3n",
        globalClass: "error",
        globalHidden: false,
        perfilesUsuarios: "",
        funciones: ""
    }

    switch (result.Estado) {
        case 2:
            _dispatch({ type: SAVE_PERMISOS_RESULT_PERMISOSMASIVOS });

            break;

        case 3:

            _dispatch({ type: SET_ERROR_MESSAGES_PERMISOSMASIVOS, messages });

            break;

        case 5:

            _dispatch({ type: SET_ERROR_MESSAGES_PERMISOSMASIVOS, messages });

            break;

        default:

            _dispatch({ type: SET_ERROR_MESSAGES_PERMISOSMASIVOS, messages });

            break;
    }

    disconectCallback();
}